export default "__VITE_ASSET__BHLH02cy__"